"use client"

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export function KeyboardNavigation() {
  const router = useRouter()

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Check if user is typing in an input or textarea
      const target = event.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return
      }

      // Navigate to floor plans when 'F' or 'f' is pressed
      if (event.key === 'f' || event.key === 'F') {
        router.push('/floor-plans')
      }
    }

    window.addEventListener('keydown', handleKeyPress)
    
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [router])

  return null
}